import React from 'react';
import ReactDOM from "react-dom/client";
import App from './App';

/*const rootNode = document.getElementById('root');
ReactDOM.render(<App />, rootNode);*/

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

